import {cloneDeep} from 'lodash-es';
import moment from "moment";
import ManagerService from "external-services/manager-service/manager.service";
import BlockOutsService from "external-services/blockouts-service/blockouts.service";
import GeneralSettingsService from "external-services/general-settings-service/generalSettings.service";
import {ChangeLogOperation} from "app/app.types";
import ViewActionsService, { BLOCKOUT_BY_TABLE } from "app/actions/view.actions";
import store from 'appRoot/Store';
import {rootDisplayActions} from "app/reducers/display/slice";
import {ToastType} from 'shared-types/SharedTypes';
import { blockoutTypeEnums } from 'app/common/BlockoutsByService/types';
import {setSelectedSchedule} from 'app/reducers/schedule/slice';


const NS = 'QuickBlockoutsCtrl'; // jshint ignore:line

export default function QuickBlockoutsCtrl(
  $rootScope, $scope, $mdToast, $mdDialog, $filter, unregister, appConstants, ToastActions, $window
) {
  "ngInject";

  const vm = this;
  let selectedTimeIndexs = [];

  //-- define public properites
  vm.isManager = ManagerService.isManager;
  //-- define public methods
  vm.newBlockout = newBlockout;
  vm.newBlockoutByService = newBlockoutByService;
  vm.newBlockoutOnFp = newBlockoutOnFp
  vm.editBlockouts = editBlockouts;
  vm.openBlockoutsMenu = openBlockoutsMenu;
  vm.closeNewBlockOut = closeNewBlockOut;
  vm.tableChecked = tableChecked;
  vm.sectionChecked = sectionChecked;
  vm.timeChecked = timeChecked;
  vm.setAllSections = setAllSections;
  vm.save = save;
  vm.staffNameRequired = false;

  //-- watch
  var listeners = [];
  listeners.push($scope.$watch('vm.closeNewBlockOut', checkOpen));
  listeners.push($scope.$watch('bookings.filterDate', closeNewBlockOut));
  listeners.push($rootScope.$on('manager-change', managerChange));
  listeners.push($scope.$on('$destroy', () => unregister(listeners)));

  listeners.push($rootScope.$on(BLOCKOUT_BY_TABLE, (e, data) => {
    switch (data.payload?.type) {
      case blockoutTypeEnums.byTableAndSection:
        newBlockout();
        break;
    }
  }));
  
  ViewActionsService.handleEditBlockout(editBlockouts);

  function managerChange() {
    vm.isManager = ManagerService.isManager;
  }

  function editBlockouts(evt) {
    $mdDialog.show({
      controller: 'BlockoutsListCtrl',
      controllerAs: 'vm',
      locals: {
        dateFor: $scope.bookings.filterDate,
        schedule: $scope.bookings.schedule
      },
      clickOutsideToClose: true,
      templateUrl: 'app/bookings/blockoutsInline/list/blockoutsList.html',
      targetEvent: evt
    });
  }

  function newBlockoutByService() {
    if ($window.config.enableBlockoutByService && $window.config.showNewBlockoutModalForTimeline) {
      store.dispatch(rootDisplayActions.setSlideModeState('new'));
      store.dispatch(rootDisplayActions.setShowBlockout(true));
    } else {
      newBlockout();
    }
  }
  function newBlockoutOnFp() {
    if ($window.config.enableBlockoutByService) {
      store.dispatch(rootDisplayActions.setSlideModeState('new'));
      store.dispatch(rootDisplayActions.setShowBlockout(true));
      store.dispatch(rootDisplayActions.setShowBlockoutOnFp(true));
    } else {
      newBlockout();
    }
  }
  /**
   * open a blockout window
   */
  function newBlockout() {
    vm.blockout = {
      name: '',
      repeatType: appConstants.Blockout.RepeatTypes.NoRepeat,
      startDateTime: null,
      endDateTime: null,
      blockedSections: [],
      blockedTables: []
    };


    selectedTimeIndexs = [];
    vm.createNewBlockout = true;
    if ($window.config.enableBlockoutByService) {
      store.dispatch(rootDisplayActions.setIsShowingNewBlockout(true));
    }
    vm.errorMsgs = [];
    $mdToast.show({
      controller: 'SaveBlockoutDailogCtrl',
      controllerAs: 'vm',
      bindToController: true,
      templateUrl: 'app/bookings/blockoutsInline/saveBlockoutDialog.html',
      hideDelay: false,
      position: 'bottom right',
      preserveScope: true,
      scope: $scope
    });
  }

  function checkOpen() {
    if (!vm.createNewBlockout) {
      closeNewBlockOut();
    }
  }

  function openBlockoutsMenu($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  }

  function closeNewBlockOut() {
    vm.createNewBlockout = false;
    store.dispatch(rootDisplayActions.setIsShowingNewBlockout(false));
    $mdToast.cancel();
    ViewActionsService.onBlockoutFinished(blockoutTypeEnums.byTableAndSection);
  }

  function tableChecked(table, layoutName) {
    if (table.selected) {
      // add the table
      var tableObj = {
        _id: table._id,
        name: table.name,
        layoutName: layoutName
      };
      vm.blockout.blockedTables.push(tableObj);
    } else {
      // remove the table
      var tableIds = vm.blockout.blockedTables.map(function (table) {
        return table._id;
      });
      var index = tableIds.indexOf(table._id);
      vm.blockout.blockedTables.splice(index, 1);
    }
    if (vm.errorMsgs.length) {
      checkErrors();
    }
  }

  function setAllSections(selected, sections, tableBySection) {
    vm.blockout.blockedTables = [];
    for (var s = sections.length - 1; s >= 0; s--) {
      var section = sections[s];
      var tables = tableBySection[section._id];
      section.selected = selected;
      sectionChecked(true, section, tables);
    }
  }

  function sectionChecked(selected, section, tables) {
    for (var i = tables.length - 1; i >= 0; i--) {
      var table = tables[i];
      table.selected = section.selected;
      tableChecked(table, section.layoutName);
    }
    if (vm.errorMsgs.length) {
      checkErrors();
    }
  }

  function timeChecked(index, intervalMarkers) {
    if (vm.blockout) {
      selectedTimeIndexs = $filter('orderBy')(selectedTimeIndexs);
      var timeMarker = intervalMarkers[index];
      var removeIndex;
      var startIndex;
      var endIndex;

      if (timeMarker.selected) {
        selectedTimeIndexs.push(index);
      } else {
        startIndex = index + 1;
        endIndex = selectedTimeIndexs[selectedTimeIndexs.length - 1];
        if (index < endIndex) {
          for (var i = startIndex; i <= endIndex; i++) {
            removeIndex = selectedTimeIndexs.indexOf(i);
            intervalMarkers[i].selected = false;
            selectedTimeIndexs.splice(removeIndex, 1);
          }
          intervalMarkers[index].selected = true;
        } else {
          removeIndex = selectedTimeIndexs.indexOf(index);
          selectedTimeIndexs.splice(removeIndex, 1);
        }
      }

      selectedTimeIndexs = $filter('orderBy')(selectedTimeIndexs);
      if (selectedTimeIndexs.length) {
        // set the start end time
        // set the start time to the first marker in the list
        vm.blockout.startDateTime = intervalMarkers[selectedTimeIndexs[0]].time;
        if (selectedTimeIndexs.length > 1) {
          vm.blockout.endDateTime = intervalMarkers[selectedTimeIndexs[selectedTimeIndexs.length - 1] + 1].time;
        } else {
          vm.blockout.endDateTime = intervalMarkers[selectedTimeIndexs[0] + 1].time;
        }
        // select markers inbetween times
        startIndex = selectedTimeIndexs[0] + 1;
        endIndex = selectedTimeIndexs[selectedTimeIndexs.length - 1];
        for (var t = startIndex; t < endIndex; t++) {
          if (selectedTimeIndexs.indexOf(t) === -1) {
            selectedTimeIndexs.push(t);
          }
          intervalMarkers[t].selected = true;
        }
      } else {
        vm.blockout.startDateTime = null;
        vm.blockout.endDateTime = null;
      }
      selectedTimeIndexs = $filter('orderBy')(selectedTimeIndexs);
      if (vm.errorMsgs.length) {
        checkErrors();
      }
    }
  }

  function checkErrors() {
    var errorMsgs = [];
    if (!vm.blockout.blockedSections.length && !vm.blockout.blockedTables.length) {
      errorMsgs.push('You must select at least one table or a section to blockout.');
    }
    if (!vm.blockout.startDateTime || !vm.blockout.endDateTime) {
      errorMsgs.push('You must select a time range to blockout.');
    }

    if(vm.staffNameRequired && !vm.blockout.staffName)
    {
      errorMsgs.push('Staff name is required.');
    }

    vm.errorMsgs = errorMsgs;
  }

  function save() {
    if ($window.config.enableBlockoutByService) {
      ViewActionsService.onBlockoutFinished(blockoutTypeEnums.byTableAndSection);
    }

    checkErrors();
    if (!vm.errorMsgs.length) {
      BlockOutsService.save(cloneDeep(vm.blockout)).then(function () {
        // Removing Manju Changes done related to ChangeLog feature - NBI-4368-Removing-manju-changelog
        // var blockoutEventValue = populateLoggingObjectForNewEvent();
        // ChangeLoggerService.save(blockoutEventValue, 'changelog_blockouts', vm.blockout.staffName, vm.blockout.name);
        closeNewBlockOut();
        if ($window.config.enableBlockoutByService) {
          ToastActions.showToast('Blockout created', ToastType.success);
          store.dispatch(setSelectedSchedule({ useCachedScheduleLookup: false }));

          setTimeout(function () {
            ToastActions.clearToast();
          }, 2000);
        }
      }).catch(function () {
        // the block failed to save
      });
    }
  }

  function populateLoggingObjectForNewEvent()
  {
    let modifiedValue = [];

    modifiedValue.push(
      {
        property: 'Blockout',
        originalValue: '',
        newValue: vm.blockout.name,
        operation: ChangeLogOperation.NewData
      }
    );

    modifiedValue.push(
      {
        property: 'StartDate',
        originalValue: '',
        newValue: moment(vm.blockout.startDateTime).format('DD MMM YY h:mma'),
        operation: ChangeLogOperation.NewData
      }
    );

    modifiedValue.push(
      {
        property: 'EndDate',
        originalValue: '',
        newValue: moment(vm.blockout.endDateTime).format('DD MMM YY h:mma'),
        operation: ChangeLogOperation.NewData
      }
    );

    return modifiedValue;
  }
}
